import React from 'react';
import { Card, CardContent, Typography, Box, Divider } from '@mui/material';
import { School } from '@mui/icons-material';

interface Education {
  degree?: string;
  fieldOfStudy?: string;
  institutionName?: string;
  institution?: string;
  endDate?: string;
  graduation_date?: string;
  grade?: string;
  gpa?: string;
}

interface ProfileEducationProps {
  education?: Education[];
}

export default function ProfileEducation({ education }: ProfileEducationProps) {
  if (!education || education.length === 0) return null;

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Box display="flex" alignItems="center" mb={2}>
          <School sx={{ mr: 1 }} />
          <Typography variant="h6">Education</Typography>
        </Box>
        {education.map((edu: Education, index: number) => (
          <Box key={index} mb={2}>
            <Typography variant="subtitle1" fontWeight="bold">
              {edu.degree || edu.fieldOfStudy || 'Degree'}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {edu.institutionName || edu.institution || 'Institution'}
            </Typography>
            {(edu.endDate || edu.graduation_date) && (
              <Typography variant="body2" color="text.secondary">
                Graduated: {edu.endDate || edu.graduation_date}
              </Typography>
            )}
            {(edu.grade || edu.gpa) && (
              <Typography variant="body2" color="text.secondary">
                GPA: {edu.grade || edu.gpa}
              </Typography>
            )}
            {index < education.length - 1 && <Divider sx={{ my: 2 }} />}
          </Box>
        ))}
      </CardContent>
    </Card>
  );
}